(function () {
  'use strict';

  function initProduct(root) {
    if (!root || root.dataset.ormeeNativeReady === 'true') return;
    root.dataset.ormeeNativeReady = 'true';

    var mainImage = root.querySelector('.ormee-native-gallery__main-image');
    var thumbs = Array.from(root.querySelectorAll('[data-ormee-thumb]'));

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        if (!mainImage || thumb.classList.contains('is-active')) return;
        mainImage.classList.add('is-changing');
        mainImage.src = thumb.dataset.imageSrc || mainImage.src;
        if (thumb.dataset.imageSrcset) mainImage.srcset = thumb.dataset.imageSrcset;
        mainImage.alt = thumb.dataset.imageAlt || '';

        thumbs.forEach(function (item) {
          var active = item === thumb;
          item.classList.toggle('is-active', active);
          item.setAttribute('aria-current', active ? 'true' : 'false');
        });

        window.setTimeout(function () {
          mainImage.classList.remove('is-changing');
        }, 180);
      });
    });

    var variantInput = root.querySelector('[data-ormee-variant-input]');
    var sellingPlanInput = root.querySelector('[data-ormee-selling-plan-input]');
    var variantSelect = root.querySelector('[data-ormee-variant-select]');
    var planSelectorWrap = root.querySelector('[data-ormee-plan-selector]');
    var planSelect = root.querySelector('[data-ormee-plan-select]');
    var purchaseRadios = Array.from(root.querySelectorAll('[data-ormee-purchase-radio]'));
    var price = root.querySelector('[data-ormee-price]');
    var priceLabel = root.querySelector('[data-ormee-price-label]');
    var priceMain = root.querySelector('[data-ormee-price-main]');
    var priceNote = root.querySelector('[data-ormee-price-note]');
    var benefits = root.querySelector('[data-ormee-subscription-benefits]');
    var submit = root.querySelector('[data-ormee-submit]');
    var cardSubscriptionPrice = root.querySelector('[data-ormee-card-subscription-price]');
    var cardRenewalPrice = root.querySelector('[data-ormee-card-renewal-price]');
    var cardOnetimePrice = root.querySelector('[data-ormee-card-onetime-price]');
    var activePlanId = root.dataset.ormeeDefaultPlanId || '';
    var available = root.dataset.ormeeAvailable === 'true';
    var labels = root.dataset;
    var sticky = root.querySelector('[data-ormee-sticky]');
    var stickyPrice = root.querySelector('[data-ormee-sticky-price]');

    function renewalLabel() {
      return (labels.ormeeLabelRenewal || '').replace('__PRICE__', price.dataset.renewalPrice || '');
    }

    function selectedPurchaseType() {
      var checked = purchaseRadios.find(function (radio) { return radio.checked; });
      return checked ? checked.value : '';
    }

    function syncPrice() {
      if (!price || !priceLabel || !priceMain || !priceNote) return;
      var selected = selectedPurchaseType();
      var subscription = selected === 'subscription' && !!activePlanId && !!price.dataset.subscriptionPrice;
      var validSelection = selected === 'onetime' || subscription;

      if (subscription) {
        priceLabel.textContent = labels.ormeeLabelInitial;
        priceMain.textContent = price.dataset.subscriptionPrice;
        priceNote.textContent = renewalLabel() + ' / ' + labels.ormeeLabelShipping;
        if (sellingPlanInput) {
          sellingPlanInput.disabled = false;
          sellingPlanInput.value = activePlanId;
        }
        if (benefits) benefits.hidden = false;
        if (planSelectorWrap) planSelectorWrap.hidden = false;
      } else {
        priceLabel.textContent = selected === 'onetime' ? labels.ormeeLabelSingle : labels.ormeeLabelChoose;
        priceMain.textContent = selected === 'onetime' ? price.dataset.onetimePrice : '—';
        priceNote.textContent = selected === 'onetime' ? labels.ormeeLabelSingleNote : labels.ormeeLabelChooseNote;
        if (sellingPlanInput) {
          sellingPlanInput.value = '';
          sellingPlanInput.disabled = true;
        }
        if (benefits) benefits.hidden = true;
        if (planSelectorWrap) planSelectorWrap.hidden = true;
      }
      if (submit) {
        submit.disabled = !available || !validSelection;
        submit.textContent = !available ? labels.ormeeLabelSoldOut : !validSelection ? labels.ormeeLabelChoose : subscription ? labels.ormeeLabelAddSubscription : labels.ormeeLabelAddSingle;
      }
      if (stickyPrice) stickyPrice.textContent = validSelection ? priceMain.textContent : '';
      if (cardRenewalPrice) cardRenewalPrice.textContent = renewalLabel();
    }

    purchaseRadios.forEach(function (radio) {
      radio.addEventListener('change', syncPrice);
    });

    if (planSelect) {
      planSelect.addEventListener('change', function () {
        var option = planSelect.options[planSelect.selectedIndex];
        if (!option || !price) return;
        price.dataset.subscriptionPrice = option.dataset.subscriptionPrice || price.dataset.subscriptionPrice;
        price.dataset.renewalPrice = option.dataset.renewalPrice || price.dataset.renewalPrice;
        activePlanId = option.value;
        if (cardSubscriptionPrice) cardSubscriptionPrice.textContent = price.dataset.subscriptionPrice;
        syncPrice();
      });
    }

    if (variantSelect) {
      variantSelect.addEventListener('change', function () {
        var option = variantSelect.options[variantSelect.selectedIndex];
        if (!option || !price) return;
        if (variantInput) variantInput.value = option.value;
        price.dataset.onetimePrice = option.dataset.onetimePrice || '';
        price.dataset.subscriptionPrice = option.dataset.subscriptionPrice || '';
        price.dataset.renewalPrice = option.dataset.renewalPrice || option.dataset.subscriptionPrice || '';
        activePlanId = option.dataset.sellingPlanId || '';
        if (cardOnetimePrice) cardOnetimePrice.textContent = price.dataset.onetimePrice;
        if (cardSubscriptionPrice) cardSubscriptionPrice.textContent = price.dataset.subscriptionPrice;
        available = option.dataset.available === 'true';
        syncPrice();
      });
    }

    syncPrice();

    if (sticky && submit && 'IntersectionObserver' in window) {
      var buttonVisible = false;
      var footerVisible = false;
      var footer = document.querySelector('footer');
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.target === submit) buttonVisible = entry.isIntersecting;
          if (entry.target === footer) footerVisible = entry.isIntersecting;
        });
        sticky.hidden = buttonVisible || footerVisible || !available;
      });
      observer.observe(submit);
      if (footer) observer.observe(footer);
      root.addEventListener('ormee:cleanup', function () { observer.disconnect(); }, { once: true });
    }

    function connectReviews() {
      var reviews = document.querySelector('.jdgm-cards-carousel, .jdgm-carousel-wrapper, .jdgm-rev-widg, [id="judgeme_product_reviews"]');
      if (reviews && !document.getElementById('ormee-reviews')) {
        var anchor = document.createElement('span');
        anchor.id = 'ormee-reviews';
        anchor.style.scrollMarginTop = '110px';
        anchor.style.display = 'block';
        reviews.before(anchor);
        return true;
      }
      return !!document.getElementById('ormee-reviews');
    }
    if (!connectReviews()) {
      var reviewsObserver = new MutationObserver(function () {
        if (connectReviews()) reviewsObserver.disconnect();
      });
      reviewsObserver.observe(document.body, { childList: true, subtree: true });
      window.setTimeout(function () { reviewsObserver.disconnect(); }, 15000);
    }
  }

  function initAll(scope) {
    var context = scope || document;
    context.querySelectorAll('[data-ormee-native-product]').forEach(initProduct);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
  document.addEventListener('shopify:section:unload', function (event) {
    event.target.querySelectorAll('[data-ormee-native-product]').forEach(function (root) {
      root.dispatchEvent(new Event('ormee:cleanup'));
    });
  });
})();


(function () {
  var main = document.getElementById('MainContent');
  if (!main || !main.querySelector('.ormee-native-product')) return;
  var initialized = new WeakSet();

  function initializeReviews() {
    main.querySelectorAll('.jdgm-cards-carousel').forEach(function (widget) {
      var wrapper = widget.querySelector('.jdgm-cards-wrapper');
      var original = widget.querySelector('.jdgm-card:not([data-clone-type])');
      var arrows = widget.querySelectorAll('.jdgm-arrow');
      if (!wrapper || !original || arrows.length !== 2 || initialized.has(wrapper)) return;
      initialized.add(wrapper);
      widget.classList.add('ormee-review-reading');
      wrapper.tabIndex = 0;
      wrapper.setAttribute('role', 'region');
      wrapper.setAttribute('aria-label', widget.querySelector('.jdgm-title').textContent.trim());
      var controls = Array.from(arrows).map(function (arrow) {
        var button = arrow.cloneNode(true);
        button.removeAttribute('onclick');
        button.type = 'button';
        arrow.replaceWith(button);
        return button;
      });

      function updateControls() {
        var max = wrapper.scrollWidth - wrapper.clientWidth;
        controls[0].disabled = wrapper.scrollLeft <= 2;
        controls[1].disabled = wrapper.scrollLeft >= max - 2;
      }

      function move(direction) {
        var cards = Array.from(wrapper.querySelectorAll('.jdgm-card:not([data-clone-type])'));
        var left = wrapper.scrollLeft;
        var start = wrapper.getBoundingClientRect().left;
        var points = cards.map(function (card) { return card.getBoundingClientRect().left - start + left; });
        var max = wrapper.scrollWidth - wrapper.clientWidth;
        var target = direction > 0 ? points.find(function (point) { return point > left + 2; }) : points.reverse().find(function (point) { return point < left - 2; });
        if (target === undefined) target = direction > 0 ? max : 0;
        wrapper.scrollTo({ left: Math.max(0, Math.min(max, target)), behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
      }

      controls[0].addEventListener('click', function () { move(-1); });
      controls[1].addEventListener('click', function () { move(1); });
      wrapper.addEventListener('scroll', updateControls, { passive: true });
      ['touchstart', 'touchmove', 'touchend', 'pointerdown'].forEach(function (name) {
        wrapper.addEventListener(name, function (event) { event.stopPropagation(); }, { capture: true, passive: true });
      });
      wrapper.addEventListener('keydown', function (event) {
        if (event.target !== wrapper || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        if (event.key === 'Home' || event.key === 'End') {
          wrapper.scrollTo({ left: event.key === 'Home' ? 0 : wrapper.scrollWidth, behavior: 'auto' });
        } else {
          move(event.key === 'ArrowRight' ? 1 : -1);
        }
      });
      if ('ResizeObserver' in window) {
        var resizeObserver = new ResizeObserver(updateControls);
        resizeObserver.observe(wrapper);
        widget.addEventListener('ormee:cleanup', function () { resizeObserver.disconnect(); }, { once: true });
      }
      updateControls();
      requestAnimationFrame(updateControls);
    });
  }

  initializeReviews();
  var observer = new MutationObserver(initializeReviews);
  observer.observe(main, { childList: true, subtree: true });
  document.addEventListener('shopify:section:unload', function (event) {
    event.target.querySelectorAll('.ormee-review-reading').forEach(function (widget) { widget.dispatchEvent(new Event('ormee:cleanup')); });
  });
})();
